import { attributes } from "@type-r/models";

export type Permissions = typeof Permissions;
export const Permissions = attributes({
    'OrderManagement': [String],
    'InvoiceManagement': [String],
    'Inmatch': [String],
    'CashflowForecasting': [String],
    'RelationshipDashboard': [String],
    'AllModules': [String]
});

export type  PermissionLevels = |'AllInBlockAdminWrite'
                                |'AllInBlockAdminViewOnly'
                                |'AllInBlockSuperuser'
                                |'OrderManagementSupplierAdmin'
                                |'OrderManagementSupplierMetrics'
                                |'OrderManagementSupplierRead'
                                |'OrderManagementSupplierSupersupplier'
                                |'OrderManagementSupplierWrite'
                                |'OrderManagementCustomerAdmin'
                                |'OrderManagementCustomerRead'
                                |'OrderManagementCustomerWrite'
                                |'OrderManagementOtherAdmin'
                                |'OrderManagementOtherRead'
                                |'InvoiceManagementSupplierAdmin'
                                |'InvoiceManagementSupplierMetrics'
                                |'InvoiceManagementSupplierRead'
                                |'InvoiceManagementSupplierSupersupplier'
                                |'InvoiceManagementSupplierWrite'
                                |'InvoiceManagementSupplierApprover'
                                |'InvoiceManagementCustomerAdmin'
                                |'InvoiceManagementCustomerRead'
                                |'InvoiceManagementCustomerWrite'
                                |'InvoiceManagementCustomerApprover'
                                |'InvoiceManagementOtherAdmin'
                                |'InvoiceManagementOtherRead'
                                |'ReconciliationSupplierAdmin'
                                |'ReconciliationSupplierMetrics'
                                |'ReconciliationSupplierRead'
                                |'ReconciliationSupplierWrite'
                                |'ReconciliationSupplierApprover'
                                |'ReconciliationOtherAdmin'
                                |'ReconciliationOtherRead'
                                | InmatchPermission;

export enum InvoiceManagementPermission {
    SupplierAdmin = 'InvoiceManagementSupplierAdmin',
    SupplierMetrics = 'InvoiceManagementSupplierMetrics',
    SupplierRead = 'InvoiceManagementSupplierRead',
    SupplierSuperSupplier = 'InvoiceManagementSupplierSupersupplier',
    SupplierWrite = 'InvoiceManagementSupplierWrite',
    SupplierApprover = 'InvoiceManagementSupplierApprover',
    CustomerAdmin = 'InvoiceManagementCustomerAdmin',
    CustomerRead = 'InvoiceManagementCustomerRead',
    CustomerWrite = 'InvoiceManagementCustomerWrite',
    CustomerApprover = 'InvoiceManagementCustomerApprover',
    OtherAdmin = 'InvoiceManagementOtherAdmin',
    OtherRead = 'InvoiceManagementOtherRead'
}

export enum OrderManagementPermission {
    SupplierRead = 'OrderManagementSupplierRead',
    SupplierSuperSupplier = 'OrderManagementSupplierSupersupplier',
    SupplierWrite = 'OrderManagementSupplierWrite',
    CustomerRead = 'OrderManagementCustomerRead',
    CustomerWrite = 'OrderManagementCustomerWrite'
}

export enum AdminPermission {
    Write = 'AllInBlockAdminWrite',
    View = 'AllInBlockAdminViewOnly'
}

export enum InmatchPermission {
    Admin = "InmatchAdmin",
    OtherAdmin = "InmatchOtherAdmin",
    OtherRead = "InmatchOtherRead",
    SupplierMetrics = 'InmatchSupplierMetrics',
    SupplierRead = 'InmatchSupplierRead',
    SupplierAnalyst = 'InmatchSupplierAnalyst',
    SupplierManager = 'InmatchSupplierManager',
    SupplierCollector = 'InmatchSupplierCollector'
}

// TODO: since those are old mappings Nikola Aleksandrov should preview those arrays and remove them

/**
 * All of those permissons are implying Customer Write permission
 */
export const InvoiceManagementCustomerWrite = [
                InvoiceManagementPermission.CustomerWrite,
                InvoiceManagementPermission.CustomerApprover
            ];

/**
 * All of those permissons are implying Supplier Write permission
 */
export const InvoiceManagementSupplierWrite = [
                InvoiceManagementPermission.SupplierWrite,
                InvoiceManagementPermission.SupplierApprover,
                InvoiceManagementPermission.SupplierSuperSupplier
            ];

/**
 * All of those permissons are implying Customer Read permission
 */
export const InvoiceManagementCustomerRead = [
                InvoiceManagementPermission.CustomerRead,
                InvoiceManagementPermission.CustomerWrite,
                InvoiceManagementPermission.CustomerApprover
            ];
/**
 * All of those permissons are implying Supplier Read permission
 */
export const InvoiceManagementSupplierRead = [
                InvoiceManagementPermission.SupplierRead,
                InvoiceManagementPermission.SupplierWrite,
                InvoiceManagementPermission.SupplierApprover,
                InvoiceManagementPermission.SupplierSuperSupplier
            ];

export const InvoiceManagementCustomerApprovalRoles = [
    InvoiceManagementPermission.CustomerWrite,
    InvoiceManagementPermission.CustomerApprover
];
export const InvoiceManagementSupplierApprovalRoles = [
    InvoiceManagementPermission.SupplierSuperSupplier
];

export enum ParticipantRoles {
    Supplier = 'Supplier',
    Customer = 'Customer',
    Other = 'Other'
}

export const InmatchSupplierWrite = [
    InmatchPermission.SupplierAnalyst,
    InmatchPermission.SupplierCollector,
    InmatchPermission.SupplierManager,
];

export const InmatchSupplierRead = [
    InmatchPermission.SupplierRead,
    ...InmatchSupplierWrite
];
